class ArrowSubMenu {
  constructor(self) {
    this.submenu = self.parentNode.querySelector(".sub-menu");
    this.arrow = self;

    self.addEventListener("click", (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();

    const allSubmenus = document.querySelectorAll(".sub-menu.active");
    const allArrows = document.querySelectorAll(".thb-arrow");

    // Close all other submenus and reset their arrows
    allSubmenus.forEach((menu) => {
      if (menu !== this.submenu) {
        menu.classList.remove("active");
      }
    });

    allArrows.forEach((arrow) => {
      if (arrow !== this.arrow) {
        arrow.setAttribute("data-state", "closed");
        arrow.querySelector(".icon-dropdown-bottom").style.display = "inline-block";
        arrow.querySelector(".icon-dropdown-top").style.display = "none";
      }
    });

    // Toggle the clicked submenu
    if (!this.submenu.classList.contains("active")) {
      this.submenu.classList.add("active");
      this.arrow.setAttribute("data-state", "open");
      this.arrow.querySelector(".icon-dropdown-bottom").style.display = "none";
      this.arrow.querySelector(".icon-dropdown-top").style.display = "inline-block";
    } else {
      this.submenu.classList.remove("active");
      this.arrow.setAttribute("data-state", "closed");
      this.arrow.querySelector(".icon-dropdown-bottom").style.display = "inline-block";
      this.arrow.querySelector(".icon-dropdown-top").style.display = "none";
    }
  }
}

// Initialize all submenu arrows
document.querySelectorAll(".thb-arrow").forEach((arrow) => {
  new ArrowSubMenu(arrow);
});
